<template>
    <div class="carbon">
        <ul>
            <li>-säure / -carbonsäure</li>
            <li>Oxidation eines Aldehyds</li>
            <li>Carboxy-</li>
            <li>Carboxylgruppe</li>
            <li>polare funktionelle Gruppe bildet H-Brücken</li>
            <li>Protolyse</li>
            <li>Esterbildung mit Alkohol</li>
            <li>Peptidbildung mit Aminogruppe</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'carbon',
};
</script>
